export type AuthType = 'signin' | 'signup';

export const langs = {
  signin: {
    type: 'Вход',
    password: 'Введите пароль',
    existence_question: 'Еще нет аккаунта?',
    main_action: 'Войти',
    alternative_action: 'Зарегистрироваться',
    sso_action: 'Авторизоваться с icPass',
  },
  signup: {
    type: 'Регистрация',
    password: 'Придумайте пароль',
    existence_question: 'Уже есть аккаунт?',
    main_action: 'Зарегистрироваться',
    alternative_action: 'Войти',
  },
};
